/**
 * Impressum – § 5 TMG
 *
 * PLATZHALTER: Vor dem Launch durch echte Kontaktdaten ersetzen.
 * Alle [PLATZHALTER]-Markierungen müssen vor Go-Live durch Anwalt/Betreiber befüllt werden.
 */

/** Impressum-Seite rendern. */
export function renderImpressum(): void {
  const app = document.getElementById('app');
  if (!app) return;

  app.innerHTML = `
    <main class="static-page">
      <h1>Impressum</h1>

      <section class="static-section">
        <h2>Angaben gemäß § 5 TMG</h2>
        <p>
          <strong>Aridara Studios</strong><br />
          Höhenweg 12<br />
          58739 Wickede (Ruhr)<br />
          Deutschland
        </p>
      </section>

      <section class="static-section">
        <h2>Kontakt</h2>
        <p>
          E-Mail: <a href="mailto:info@aridarastudios.de">info@aridarastudios.de</a>
        </p>
      </section>

      <section class="static-section">
        <h2>Umsatzsteuer-ID</h2>
        <p>
          DE453662996
        </p>
      </section>

      <section class="static-section">
        <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
        <p>
          Chris Wiedemaier<br />
          Höhenweg 12<br />
          58739 Wickede (Ruhr)<br />
          Deutschland
        </p>
      </section>

      <section class="static-section">
        <h2>Hinweis zur Plattform</h2>
        <p>
          nighttrade ist ein fiktives Browser-Spiel mit satirischem Charakter.
          Alle dargestellten Aktivitäten, Personen und Organisationen sind frei erfunden.
          Jede Ähnlichkeit mit real existierenden Personen oder Ereignissen ist rein zufällig.
        </p>
        <p>
          Die Plattform richtet sich ausschließlich an Personen ab 18 Jahren (§ 8 DSGVO).
        </p>
      </section>

      <div class="static-back">
        <a href="/">← Zurück zur Startseite</a>
      </div>
    </main>
  `;
}
